import React from 'react';
import { motion } from 'framer-motion';

export const ThesisOverview = () => {
    return (
        <section className="py-20 px-8 max-w-7xl mx-auto">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="mb-12"
            >
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-black text-gray-900 tracking-tight mb-4">Thesis Overview</h2>
                    <p className="text-lg text-gray-500 font-medium max-w-2xl mx-auto">
                        A high-level architectural view of the Normative Reinforcement Control Framework (NRCF).
                    </p>
                </div>

                <div className="rounded-3xl overflow-hidden shadow-2xl border border-gray-100 bg-white">
                    <img
                        src="/images/NRCF_overall_thesis.png"
                        alt="NRCF Overall Thesis Architecture"
                        className="w-full h-auto object-cover"
                    />
                </div>
            </motion.div>
        </section>
    );
};
